<template>
  <div>
    <div class="banner">
      <div class="banner-box">
        <div>
          <h2>
            FAQ
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row my-5">
        <div class="col-md-12">
          <div class="d-flex justify-content-start mb-5" >
            <button v-if="allQuestionsList" type="button" @click="questionsList = allQuestionsList" class="btn btn-brown mr-3">全部</button>
            <button v-for="(item, index) in faq" :key="index" @click="selectedCategory(index)"  type="button" class="btn btn-brown mx-3">{{ item.q }}</button>
          </div>
          <div v-for="(item, index) in questionsList" class="accordion">
            <div class="card">
              <div class="card-header" :id="`heading${index}`">
                <h2 class="mb-0">
                  <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="`#collapse${index}`" aria-expanded="true" aria-controls="collapseOne">
                    Q: {{ item.q }}
                  </button>
                </h2>
              </div>
              <div :id="`collapse${index}`" class="collapse" :aria-labelledby="`heading${index}`" >
                <div class="card-body">
                  {{ item.a }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import api from '../store/api'
export default {
  name: 'FAQ',
  watch: {
  },
  data () {
    return {
      faq: [],
      questionsList: [],
      allQuestionsList: []
    }
  },
  mounted () {
    this.scrollTop()
    this.getFAQ()
  },
  methods: {
    async getFAQ () {
      const { data } = await api.get(`/faq?device=web`)
      const faq = data.data
      this.faq = data.data
      let questionsList = []
      for(let i = 0; i <faq.length; i++){
        questionsList = questionsList.concat(faq[i].questions)
      }
      this.allQuestionsList = questionsList
      this.questionsList = this.allQuestionsList
    },
    selectedCategory (id) {
      this.questionsList = this.faq[id].questions
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../assets/styles/color.scss";
  @import "../assets/styles/custom.scss";
  .container {
    text-align: left;
  }
  .btn-block:focus {
    box-shadow: none;
  }
  .banner {
    height: 250px;
    background-image: url('../assets/image/pic/banner_bg_welcome_top.jpg');
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-position: center;
    background-size: cover;
    .banner-box {
      padding: 60px 0 10px 0;
      h2 {
        font-size: 3rem;
        font-weight: 800;
        margin-bottom: 1rem;
      }
      p {
        font-weight: 600;
        margin: 0;
        font-size: 1.25rem;
      }
    }
  }
  .btn-brown,
  .btn-brown:hover,
  .btn-brown:active,
  .btn-brown:visited,
  .btn-brown:focus {
    color: #fff;
    background-color: #b86910 !important;
    border-color: #b86910 !important;
    box-shadow: none;
  }
</style>
